import * as Icons from '@ant-design/icons';
import { Button } from 'antd';
import { DocumentsByTemplateMap } from './DocumentList';
import { ModalUploadDocument } from './ModalUploadDocument';
import { useDocumentationStore } from '../documentation-store';
import { useState } from 'react';

interface EmptyDocumentActionsProps {
  templateData: DocumentsByTemplateMap;
}

export const EmptyDocumentActions = ({
  templateData
}: EmptyDocumentActionsProps) => {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const queryHandler = useDocumentationStore(s => s.queryHandler);

  return (
    <div>
      <Button
        icon={<Icons.UploadOutlined />}
        onClick={() => setUploadModalOpen(true)}
      >
        Upload
      </Button>

      <ModalUploadDocument
        modalProps={{
          open: uploadModalOpen,
          onCancel: () => setUploadModalOpen(false)
        }}
        modalClose={() => setUploadModalOpen(false)}
        templateId={templateData.template_id}
        refetch={queryHandler}
      />
    </div>
  );
};
